// src/screens/components/InformeModal.jsx
import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';

export default function InformeModal({ equipo, onClose }) {
  const pieData = [
    { name: 'Caudal entregado', value: 90 },
    { name: 'Déficit', value: 5 }
  ];
  const colors = ['#60a5fa', '#f87171'];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-xl font-bold"
        >
          ×
        </button>
        <h3 className="text-xl font-semibold mb-4 text-center">
          Informe del Equipo
        </h3>
        <table className="w-full text-sm text-left border border-gray-200 rounded-xl overflow-hidden shadow mb-5">
          <tbody>
            <tr className="border-b">
              <td className="px-4 py-2 font-medium bg-gray-50">Estado</td>
              <td className="px-4 py-2">{equipo.estadoDescripcion}</td>
            </tr>
            <tr className="border-b">
              <td className="px-4 py-2 font-medium bg-gray-50">Caudal esperado</td>
              <td className="px-4 py-2">95 m³/s</td>
            </tr>
            <tr className="border-b">
              <td className="px-4 py-2 font-medium bg-gray-50">Caudal entregado</td>
              <td className="px-4 py-2">90 m³/s</td>
            </tr>
            <tr>
              <td className="px-4 py-2 font-medium bg-gray-50">Déficit</td>
              <td className="px-4 py-2">5 m³/s</td>
            </tr>
          </tbody>
        </table>
        <div className="flex justify-center gap-6 mb-3 text-sm font-medium">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-blue-400"></div>
            <span>Caudal entregado</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-red-400"></div>
            <span>Déficit</span>
          </div>
        </div>
        <div className="flex justify-center">
          <PieChart width={250} height={220}>
            <Pie data={pieData} cx="50%" cy="50%" outerRadius={70} dataKey="value">
              {pieData.map((e, i) => (
                <Cell key={i} fill={colors[i % colors.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </div>
      </div>
    </div>
  );
}
